// extracted by mini-css-extract-plugin
export default {"terms-container":"Terms_terms-container__IBi8k","terms-content":"Terms_terms-content__Cn7or"};